import { render } from "./SettingPassword.vue?vue&type=template&id=0e85f3fa"
import script from "./SettingPassword.vue?vue&type=script&lang=js"
export * from "./SettingPassword.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__